// src/components/SmileSection.js
import React, { useEffect, useRef, useState } from 'react';

const SmileSection = () => {

    return (


        <div className="WordSection1 container">
            <p className="MsoNormal">
                <b>
                    <span lang="EN-GB">Introduction</span>
                </b>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">&nbsp;</span>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">
                    Welcome to the Alignar website privacy policy.&nbsp;
                    <br />
                    <br />
                    K Liner UK Ltd respects your privacy and is committed to protecting your
                    personal data. This privacy policy will inform you as to how we look
                    after your personal data when you visit our website (regardless of where
                    you visit it from) and tell you about your privacy rights and how the
                    law protects you.&nbsp;
                    <br />
                    <br />
                    This privacy policy is provided in a layered format so you can click
                    through to the specific areas set out below. Please also use the
                    Glossary to understand the meaning of some of the terms used in this
                    privacy policy.
                </span>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">&nbsp;</span>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">
                    1. Important information and who we are&nbsp;
                    <br />
                    2. The data we collect about you&nbsp;
                    <br />
                    3. How is your personal data collected?&nbsp;
                    <br />
                    4. How we use your personal data&nbsp;
                    <br />
                    5. Disclosures of your personal data&nbsp;
                    <br />
                    6. International transfers&nbsp;
                    <br />
                    7. Data security&nbsp;
                    <br />
                    8. Data retention&nbsp;
                    <br />
                    9. Your legal rights&nbsp;
                    <br />
                    10. Glossary
                </span>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">&nbsp;</span>
            </p>
            <p className="MsoNormal">
                <b>
                    <span lang="EN-GB">1. Important information and who we are</span>
                </b>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">
                    <br />
                    <b>Purpose of this privacy policy</b>
                </span>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">
                    This privacy policy aims to give you information on how K Liner UK Ltd
                    collects and processes your personal data through your use of this
                    website, including any data you may provide through this website when
                    you sign up to receive information about our services.&nbsp;
                    <br />
                    <br />
                    This website is not intended for children and we do not knowingly
                    collect data relating to children.&nbsp;
                    <br />
                    <br />
                    It is important that you read this privacy policy together with any
                    other privacy policy or fair processing policy we may provide on
                    specific occasions when we are collecting or processing personal data
                    about you so that you are fully aware of how and why we are using your
                    data. This privacy policy supplements other notices and privacy policies
                    and is not intended to override them.&nbsp;
                    <br />
                    <br />
                    <br />
                </span>
            </p>
            <p className="MsoNormal">
                <b>
                    <span lang="EN-GB">Controller</span>
                </b>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">
                    K Liner UK Ltd is the controller and responsible for your personal data
                    (collectively referred to as "K Liner UK Ltd", "we", "us" or "our" in
                    this privacy policy).&nbsp;
                    <br />
                    <br />
                    If you have any questions about this privacy policy, including any
                    requests to exercise your legal rights, please contact us using the
                    details set out below.&nbsp;
                    <br />
                    <br />
                    <br />
                </span>
            </p>
            <p className="MsoNormal">
                <b>
                    <span lang="EN-GB">Contact details</span>
                </b>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">
                    If you have any questions about this privacy policy or our privacy
                    practices, please contact us in the following ways:&nbsp;
                    <br />
                    <br />
                    Full name of legal entity: K Liner UK Ltd&nbsp;
                    <br />
                    <br />
                    Email address: info@alignar.com
                    <br />
                    <br />
                    Postal address: 43 Berkeley Square, London, England, W1J 5AP&nbsp;
                    <br />
                    <br />
                    You have the right to make a complaint at any time to the Information
                    Commissioner's Office (ICO), the UK regulator for data protection issues
                    (www.ico.org.uk). We would, however, appreciate the chance to deal with
                    your concerns before you approach the ICO so please contact us in the
                    first instance.&nbsp;
                    <br />
                    <br />
                    <br />
                </span>
            </p>
            <p className="MsoNormal">
                <b>
                    <span lang="EN-GB">
                        Changes to the privacy policy and your duty to inform us of changes
                    </span>
                </b>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">
                    We keep our privacy policy under regular review.&nbsp;
                    <br />
                    <br />
                    It is important that the personal data we hold about you is accurate and
                    current. Please keep us informed if your personal data changes during
                    your relationship with us.&nbsp;
                    <br />
                    <br />
                    <br />
                </span>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">Third-party links</span>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">
                    This website may include links to third-party websites, plug-ins and
                    applications. Clicking on those links or enabling those connections may
                    allow third parties to collect or share data about you. We do not
                    control these third-party websites and are not responsible for their
                    privacy statements. When you leave our website, we encourage you to read
                    the privacy policy of every website you visit.&nbsp;
                    <br />
                    <br />
                    <br />
                </span>
            </p>
            <p className="MsoNormal">
                <b>
                    <span lang="EN-GB">2. The data we collect about you</span>
                </b>
            </p>
            <p className="MsoNormal">
                <b>
                    <span lang="EN-GB">&nbsp;</span>
                </b>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">
                    Personal data, or personal information, means any information about an
                    individual from which that person can be identified. It does not include
                    data where the identity has been removed (anonymous data).&nbsp;
                    <br />
                    <br />
                    We may collect, use, store and transfer different kinds of personal data
                    about you which we have grouped together as follows:&nbsp;
                    <br />
                    <b>• Identity Data</b>&nbsp;includes first name, maiden name, last name,
                    username or similar identifier, information about your teeth as set out
                    on our ‘Can You Treat Me’ page, title, date of birth and gender.&nbsp;
                    <br />
                    <b>• Contact Data</b>&nbsp;includes email address and phone
                    number.&nbsp;
                    <br />
                    <b>• Technical Data</b>&nbsp;includes internet protocol (IP) address,
                    your login data, browser type and version, time zone setting and
                    location, browser plug-in types and versions, operating system and
                    platform, and other technology on the devices you use to access this
                    website.&nbsp;
                    <br />
                    <b>• Usage Data</b>&nbsp;includes information about how you use our
                    website, products and services.&nbsp;
                    <br />
                    <b>• Marketing and Communications Data</b>&nbsp;includes your
                    preferences in receiving marketing from us and our third parties and
                    your communication preferences.&nbsp;
                    <br />
                    <br />
                    We also collect, use and share&nbsp;<b>Aggregated Data</b>&nbsp;such as
                    statistical or demographic data for any purpose. Aggregated Data could
                    be derived from your personal data but is not considered personal data
                    in law as this data will not directly or indirectly reveal your
                    identity. For example, we may aggregate your Usage Data to calculate the
                    percentage of users accessing a specific website feature. However, if we
                    combine or connect Aggregated Data with your personal data so that it
                    can directly or indirectly identify you, we treat the combined data as
                    personal data which will be used in accordance with this privacy
                    policy.&nbsp;
                    <br />
                    <br />
                    We do not collect any&nbsp;<b>Special Categories of Personal Data</b>
                    &nbsp;about you (this includes details about your race or ethnicity,
                    religious or philosophical beliefs, sex life, sexual orientation,
                    political opinions, trade union membership, information about your
                    health, and genetic and biometric data). Nor do we collect any
                    information about criminal convictions and offences.&nbsp;
                    <br />
                    <br />
                    <br />
                </span>
            </p>
            <p className="MsoNormal">
                <b>
                    <span lang="EN-GB">If you fail to provide personal data</span>
                </b>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">
                    Where we need to collect personal data by law, or under the terms of a
                    contract we have with you, and you fail to provide that data when
                    requested, we may not be able to perform the contract we have or are
                    trying to enter into with you (for example, to provide you with goods or
                    services). In this case, we may have to cancel a product or service you
                    have with us but we will notify you if this is the case at the
                    time.&nbsp;
                    <br />
                    <br />
                    <br />
                </span>
            </p>
            <p className="MsoNormal">
                <b>
                    <span lang="EN-GB">3. How is your personal data collected?</span>
                </b>
            </p>
            <p className="MsoNormal">
                <b>
                    <span lang="EN-GB">&nbsp;</span>
                </b>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">
                    We use different methods to collect data from and about you including
                    through:&nbsp;
                    <br />
                    <b>• Direct interactions.</b>&nbsp;You may give us your Identity and
                    Contact Data by filling in forms or by corresponding with us by post,
                    phone, email or otherwise. This includes personal data you provide when
                    you:&nbsp;
                    <br />
                    • apply for our products or services;&nbsp;
                    <br />
                    • request marketing to be sent to you; or&nbsp;
                    <br />
                    • give us feedback or contact us.&nbsp;
                    <br />
                    <b>• Automated technologies or interactions.</b>&nbsp;As you interact
                    with our website, we will automatically collect Technical Data about
                    your equipment, browsing actions and patterns. We collect this personal
                    data by using cookies, server logs and other similar technologies.
                    Please see our&nbsp;
                    <a href="https://smilefast.com/cookie-policy">
                        <b>cookie policy</b>
                    </a>
                    &nbsp;for further details.&nbsp;
                    <br />
                    <br />
                    <br />
                </span>
            </p>
            <p className="MsoNormal">
                <b>
                    <span lang="EN-GB">4. How we use your personal data</span>
                </b>
            </p>
            <p className="MsoNormal">
                <b>
                    <span lang="EN-GB">&nbsp;</span>
                </b>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">
                    We will only use your personal data when the law allows us to. Most
                    commonly, we will use your personal data in the following
                    circumstances:&nbsp;
                    <br />
                    • Where we need to perform the contract we are about to enter into or
                    have entered into with you.&nbsp;
                    <br />
                    • Where it is necessary for our legitimate interests (or those of a
                    third party) and your interests and fundamental rights do not override
                    those interests.&nbsp;
                    <br />• Where we need to comply with a legal obligation.&nbsp;
                    <a href="https://smilefast.com/privacy_policy#ten">
                        <b>Click here</b>
                    </a>
                    &nbsp;to find out more about the types of lawful basis that we will rely
                    on to process your personal data.&nbsp;
                    <br />
                    <br />
                    Generally, we do not rely on consent as a legal basis for processing
                    your personal data although we will get your consent before sending
                    third party direct marketing communications to you via email or text
                    message. You have the right to withdraw consent to marketing at any time
                    by contacting us.&nbsp;
                    <br />
                    <br />
                    <br />
                </span>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">
                    Purposes for which we will use your personal data
                </span>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">
                    We have set out below, in a table format, a description of all the ways
                    we plan to use your personal data, and which of the legal bases we rely
                    on to do so. We have also identified what our legitimate interests are
                    where appropriate.&nbsp;
                    <br />
                    <br />
                    Note that we may process your personal data for more than one lawful
                    ground depending on the specific purpose for which we are using your
                    data. Please contact us if you need details about the specific legal
                    ground we are relying on to process your personal data where more than
                    one ground has been set out in the table below.
                </span>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">&nbsp;</span>
            </p>
            <table
                className="MsoNormalTable"
                border={0}
                cellSpacing={0}
                cellPadding={0}
                width={1110}
                style={{ width: "832.5pt", borderCollapse: "collapse" }}
            >
                <thead>
                    <tr>
                        <td
                            valign="bottom"
                            style={{
                                border: "solid #DEE2E6 1.0pt",
                                borderBottom: "solid #DEE2E6 1.5pt",
                                padding: ".75pt .75pt .75pt .75pt"
                            }}
                        >
                            <p className="MsoNormal">
                                <b>
                                    <span lang="EN-GB" style={{ fontSize: "10.0pt" }}>
                                        Purpose/Activity
                                    </span>
                                </b>
                            </p>
                        </td>
                        <td
                            valign="bottom"
                            style={{
                                borderTop: "solid #DEE2E6 1.0pt",
                                borderLeft: "none",
                                borderBottom: "solid #DEE2E6 1.5pt",
                                borderRight: "solid #DEE2E6 1.0pt",
                                padding: ".75pt .75pt .75pt .75pt"
                            }}
                        >
                            <p className="MsoNormal">
                                <b>
                                    <span lang="EN-GB" style={{ fontSize: "10.0pt" }}>
                                        Type of data
                                    </span>
                                </b>
                            </p>
                        </td>
                        <td
                            valign="bottom"
                            style={{
                                borderTop: "solid #DEE2E6 1.0pt",
                                borderLeft: "none",
                                borderBottom: "solid #DEE2E6 1.5pt",
                                borderRight: "solid #DEE2E6 1.0pt",
                                padding: ".75pt .75pt .75pt .75pt"
                            }}
                        >
                            <p className="MsoNormal">
                                <b>
                                    <span lang="EN-GB" style={{ fontSize: "10.0pt" }}>
                                        Lawful basis for processing including basis of legitimate
                                        interest
                                    </span>
                                </b>
                            </p>
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td
                            valign="top"
                            style={{
                                border: "solid #DEE2E6 1.0pt",
                                borderTop: "none",
                                padding: ".75pt .75pt .75pt .75pt"
                            }}
                        >
                            <p className="MsoNormal">
                                <span lang="EN-GB" style={{ fontSize: "10.0pt" }}>
                                    To connect you with a dentist who will offer you an examination
                                    and check your suitability for treatment&nbsp;
                                </span>
                            </p>
                        </td>
                        <td
                            valign="top"
                            style={{
                                borderTop: "none",
                                borderLeft: "none",
                                borderBottom: "solid #DEE2E6 1.0pt",
                                borderRight: "solid #DEE2E6 1.0pt",
                                padding: ".75pt .75pt .75pt .75pt"
                            }}
                        >
                            <p className="MsoNormal">
                                <span lang="EN-GB" style={{ fontSize: "10.0pt" }}>
                                    (a) Identity&nbsp;
                                    <br />
                                    (b) Contact
                                </span>
                            </p>
                        </td>
                        <td
                            valign="top"
                            style={{
                                borderTop: "none",
                                borderLeft: "none",
                                borderBottom: "solid #DEE2E6 1.0pt",
                                borderRight: "solid #DEE2E6 1.0pt",
                                padding: ".75pt .75pt .75pt .75pt"
                            }}
                        >
                            <p className="MsoNormal">
                                <span lang="EN-GB" style={{ fontSize: "10.0pt" }}>
                                    (a) Performance of a contract with you&nbsp;
                                    <br />
                                    (b) Necessary for our legitimate interests (to deliver products
                                    and services)
                                </span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            valign="top"
                            style={{
                                border: "solid #DEE2E6 1.0pt",
                                borderTop: "none",
                                padding: ".75pt .75pt .75pt .75pt"
                            }}
                        >
                            <p className="MsoNormal">
                                <span lang="EN-GB" style={{ fontSize: "10.0pt" }}>
                                    To manage our relationship with you which will include: (a)
                                    Notifying you about changes to our terms or privacy policy&nbsp;
                                    <br />
                                    (b) Asking you to leave a review or take a survey
                                </span>
                            </p>
                        </td>
                        <td
                            valign="top"
                            style={{
                                borderTop: "none",
                                borderLeft: "none",
                                borderBottom: "solid #DEE2E6 1.0pt",
                                borderRight: "solid #DEE2E6 1.0pt",
                                padding: ".75pt .75pt .75pt .75pt"
                            }}
                        >
                            <p className="MsoNormal">
                                <span lang="EN-GB" style={{ fontSize: "10.0pt" }}>
                                    (a) Identity&nbsp;
                                    <br />
                                    (b) Contact&nbsp;
                                    <br />
                                    (c) Marketing and Communications
                                </span>
                            </p>
                        </td>
                        <td
                            valign="top"
                            style={{
                                borderTop: "none",
                                borderLeft: "none",
                                borderBottom: "solid #DEE2E6 1.0pt",
                                borderRight: "solid #DEE2E6 1.0pt",
                                padding: ".75pt .75pt .75pt .75pt"
                            }}
                        >
                            <p className="MsoNormal">
                                <span lang="EN-GB" style={{ fontSize: "10.0pt" }}>
                                    (a) Performance of a contract with you&nbsp;
                                    <br />
                                    (b) Necessary to comply with a legal obligation&nbsp;
                                    <br />
                                    (c) Necessary for our legitimate interests (to keep our records
                                    updated and to study how customers use our products/services)
                                </span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            valign="top"
                            style={{
                                border: "solid #DEE2E6 1.0pt",
                                borderTop: "none",
                                padding: ".75pt .75pt .75pt .75pt"
                            }}
                        >
                            <p className="MsoNormal">
                                <span lang="EN-GB" style={{ fontSize: "10.0pt" }}>
                                    To enable you to complete a survey
                                </span>
                            </p>
                        </td>
                        <td
                            valign="top"
                            style={{
                                borderTop: "none",
                                borderLeft: "none",
                                borderBottom: "solid #DEE2E6 1.0pt",
                                borderRight: "solid #DEE2E6 1.0pt",
                                padding: ".75pt .75pt .75pt .75pt"
                            }}
                        >
                            <p className="MsoNormal">
                                <span lang="EN-GB" style={{ fontSize: "10.0pt" }}>
                                    (a) Identity&nbsp;
                                    <br />
                                    (b) Contact&nbsp;
                                    <br />
                                    (c) Usage&nbsp;
                                    <br />
                                    (d) Marketing and Communications
                                </span>
                            </p>
                        </td>
                        <td
                            valign="top"
                            style={{
                                borderTop: "none",
                                borderLeft: "none",
                                borderBottom: "solid #DEE2E6 1.0pt",
                                borderRight: "solid #DEE2E6 1.0pt",
                                padding: ".75pt .75pt .75pt .75pt"
                            }}
                        >
                            <p className="MsoNormal">
                                <span lang="EN-GB" style={{ fontSize: "10.0pt" }}>
                                    (a) Performance of a contract with you&nbsp;
                                    <br />
                                    (b) Necessary for our legitimate interests (to study how
                                    customers use our products/services, to develop them and grow
                                    our business)
                                </span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            valign="top"
                            style={{
                                border: "solid #DEE2E6 1.0pt",
                                borderTop: "none",
                                padding: ".75pt .75pt .75pt .75pt"
                            }}
                        >
                            <p className="MsoNormal">
                                <span lang="EN-GB" style={{ fontSize: "10.0pt" }}>
                                    To administer and protect our business and this website
                                    (including troubleshooting, data analysis, testing, system
                                    maintenance, support, reporting and hosting of data)&nbsp;
                                </span>
                            </p>
                        </td>
                        <td
                            valign="top"
                            style={{
                                borderTop: "none",
                                borderLeft: "none",
                                borderBottom: "solid #DEE2E6 1.0pt",
                                borderRight: "solid #DEE2E6 1.0pt",
                                padding: ".75pt .75pt .75pt .75pt"
                            }}
                        >
                            <p className="MsoNormal">
                                <span lang="EN-GB" style={{ fontSize: "10.0pt" }}>
                                    (a) Identity&nbsp;
                                    <br />
                                    (b) Contact&nbsp;
                                    <br />
                                    (c) Technical
                                </span>
                            </p>
                        </td>
                        <td
                            valign="top"
                            style={{
                                borderTop: "none",
                                borderLeft: "none",
                                borderBottom: "solid #DEE2E6 1.0pt",
                                borderRight: "solid #DEE2E6 1.0pt",
                                padding: ".75pt .75pt .75pt .75pt"
                            }}
                        >
                            <p className="MsoNormal">
                                <span lang="EN-GB" style={{ fontSize: "10.0pt" }}>
                                    (a) Necessary for our legitimate interests (for running our
                                    business, provision of administration and IT services, network
                                    security, to prevent fraud and in the context of a business
                                    reorganisation or group restructuring exercise)&nbsp;
                                    <br />
                                    (b) Necessary to comply with a legal obligation
                                </span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            valign="top"
                            style={{
                                border: "solid #DEE2E6 1.0pt",
                                borderTop: "none",
                                padding: ".75pt .75pt .75pt .75pt"
                            }}
                        >
                            <p className="MsoNormal">
                                <span lang="EN-GB" style={{ fontSize: "10.0pt" }}>
                                    To use data analytics to improve our website, products/services,
                                    marketing, customer relationships and experiences
                                </span>
                            </p>
                        </td>
                        <td
                            valign="top"
                            style={{
                                borderTop: "none",
                                borderLeft: "none",
                                borderBottom: "solid #DEE2E6 1.0pt",
                                borderRight: "solid #DEE2E6 1.0pt",
                                padding: ".75pt .75pt .75pt .75pt"
                            }}
                        >
                            <p className="MsoNormal">
                                <span lang="EN-GB" style={{ fontSize: "10.0pt" }}>
                                    (a) Technical&nbsp;
                                    <br />
                                    (b) Usage
                                </span>
                            </p>
                        </td>
                        <td
                            valign="top"
                            style={{
                                borderTop: "none",
                                borderLeft: "none",
                                borderBottom: "solid #DEE2E6 1.0pt",
                                borderRight: "solid #DEE2E6 1.0pt",
                                padding: ".75pt .75pt .75pt .75pt"
                            }}
                        >
                            <p className="MsoNormal">
                                <span lang="EN-GB" style={{ fontSize: "10.0pt" }}>
                                    Necessary for our legitimate interests (to define types of
                                    customers for our products and services, to keep our website
                                    updated and relevant, to develop our business and to inform our
                                    marketing strategy)
                                </span>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            valign="top"
                            style={{
                                border: "solid #DEE2E6 1.0pt",
                                borderTop: "none",
                                padding: ".75pt .75pt .75pt .75pt"
                            }}
                        >
                            <p className="MsoNormal">
                                <span lang="EN-GB" style={{ fontSize: "10.0pt" }}>
                                    To make suggestions and recommendations to you about goods or
                                    services that may be of interest to you
                                </span>
                            </p>
                        </td>
                        <td
                            valign="top"
                            style={{
                                borderTop: "none",
                                borderLeft: "none",
                                borderBottom: "solid #DEE2E6 1.0pt",
                                borderRight: "solid #DEE2E6 1.0pt",
                                padding: ".75pt .75pt .75pt .75pt"
                            }}
                        >
                            <p className="MsoNormal">
                                <span lang="EN-GB" style={{ fontSize: "10.0pt" }}>
                                    (a) Identity&nbsp;
                                    <br />
                                    (b) Contact&nbsp;
                                    <br />
                                    (c) Technical&nbsp;
                                    <br />
                                    (d) Usage&nbsp;
                                    <br />
                                    (e) Marketing and Communications
                                </span>
                            </p>
                        </td>
                        <td
                            valign="top"
                            style={{
                                borderTop: "none",
                                borderLeft: "none",
                                borderBottom: "solid #DEE2E6 1.0pt",
                                borderRight: "solid #DEE2E6 1.0pt",
                                padding: ".75pt .75pt .75pt .75pt"
                            }}
                        >
                            <p className="MsoNormal">
                                <span lang="EN-GB" style={{ fontSize: "10.0pt" }}>
                                    Necessary for our legitimate interests (to develop our
                                    products/services and grow our business)
                                </span>
                            </p>
                        </td>
                    </tr>
                </tbody>
            </table>
            <p className="MsoNormal">
                <span lang="EN-GB">
                    <br />
                    <br />
                    <br />
                </span>
            </p>
            <p className="MsoNormal">
                <b>
                    <span lang="EN-GB">Marketing</span>
                </b>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">
                    We strive to provide you with choices regarding certain personal data
                    uses, particularly around marketing and advertising. We have established
                    the following personal data control mechanisms:&nbsp;
                    <br />
                    <br />
                    <br />
                </span>
            </p>
            <p className="MsoNormal">
                <b>
                    <span lang="EN-GB">Promotional offers from us</span>
                </b>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">
                    We may use your Identity, Contact, Technical, Usage and Profile Data to
                    form a view on what we think you may want or need, or what may be of
                    interest to you. This is how we decide which products, services and
                    offers may be relevant for you (we call this marketing).&nbsp;
                    <br />
                    <br />
                    You will receive marketing communications from us if you have requested
                    information from us or purchased goods or services from us and you have
                    not opted out of receiving that marketing.&nbsp;
                    <br />
                    <br />
                    <br />
                </span>
            </p>
            <p className="MsoNormal">
                <b>
                    <span lang="EN-GB">Third-party marketing</span>
                </b>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">
                    We will get your express opt-in consent before we share your personal
                    data with any third party for marketing purposes.&nbsp;
                    <br />
                    <br />
                    <br />
                </span>
            </p>
            <p className="MsoNormal">
                <b>
                    <span lang="EN-GB">Opting out</span>
                </b>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">
                    You can ask us or third parties to stop sending you marketing messages
                    at any by contacting us at any time.&nbsp;
                    <br />
                    <br />
                    Where you opt out of receiving these marketing messages, this will not
                    apply to personal data provided to us as a result of a product/service
                    purchase.&nbsp;
                    <br />
                    <br />
                    <br />
                </span>
            </p>
            <p className="MsoNormal">
                <b>
                    <span lang="EN-GB">Cookies</span>
                </b>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">
                    You can set your browser to refuse all or some browser cookies, or to
                    alert you when websites set or access cookies. If you disable or refuse
                    cookies, please note that some parts of this website may become
                    inaccessible or not function properly. For more information about the
                    cookies we use,&nbsp;
                    <a href="https://smilefast.com/cookie-policy">
                        <b>please see</b>
                    </a>
                    &nbsp;
                    <br />
                    <br />
                    <br />
                </span>
            </p>
            <p className="MsoNormal">
                <b>
                    <span lang="EN-GB">Change of purpose</span>
                </b>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">
                    We will only use your personal data for the purposes for which we
                    collected it, unless we reasonably consider that we need to use it for
                    another reason and that reason is compatible with the original purpose.
                    If you wish to get an explanation as to how the processing for the new
                    purpose is compatible with the original purpose, please contact
                    us.&nbsp;
                    <br />
                    <br />
                    If we need to use your personal data for an unrelated purpose, we will
                    notify you and we will explain the legal basis which allows us to do
                    so.&nbsp;
                    <br />
                    <br />
                    Please note that we may process your personal data without your
                    knowledge or consent, in compliance with the above rules, where this is
                    required or permitted by law.&nbsp;
                    <br />
                    <br />
                    <br />
                </span>
            </p>
            <p className="MsoNormal">
                <b>
                    <span lang="EN-GB">5. Disclosures of your personal data</span>
                </b>
            </p>
            <p className="MsoNormal">
                <b>
                    <span lang="EN-GB">&nbsp;</span>
                </b>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">
                    We may share your personal data with the parties set out below for the
                    purposes set out in the table Purposes for which we will use your
                    personal data above.&nbsp;
                    <br />
                    <br />
                    • External Third Parties as set out in the Glossary.&nbsp;
                    <br />
                    <br />
                    • Third parties to whom we may choose to sell, transfer or merge parts
                    of our business or our assets. Alternatively, we may seek to acquire
                    other businesses or merge with them. If a change happens to our
                    business, then the new owners may use your personal data in the same way
                    as set out in this privacy policy. We require all third parties to
                    respect the security of your personal data and to treat it in accordance
                    with the law. We do not allow our third-party service providers to use
                    your personal data for their own purposes and only permit them to
                    process your personal data for specified purposes and in accordance with
                    our instructions.&nbsp;
                    <br />
                    <br />
                    <br />
                </span>
            </p>
            <p className="MsoNormal">
                <b>
                    <span lang="EN-GB">6. International transfers</span>
                </b>
            </p>
            <p className="MsoNormal">
                <b>
                    <span lang="EN-GB">&nbsp;</span>
                </b>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">
                    Some of our external third party suppliers are based outside the UK so
                    their processing of your personal data will involve a transfer of data
                    outside the UK.&nbsp;
                    <br />
                    <br />
                    Whenever we transfer your personal data out of the UK, we ensure a
                    similar degree of protection is afforded to it by ensuring at least one
                    of the following safeguards is implemented:&nbsp;
                    <br />
                    <br />
                    • We will only transfer your personal data to countries that have been
                    deemed to provide an adequate level of protection for personal
                    data.&nbsp;
                    <br />
                    <br />
                    • Where we use certain service providers, we may use specific contracts
                    approved for use in the UK which give personal data the same protection
                    it has in the UK. Please contact us if you want further information on
                    the specific mechanism used by us when transferring your personal data
                    out of the UK.&nbsp;
                    <br />
                    <br />
                    <br />
                </span>
            </p>
            <p className="MsoNormal">
                <b>
                    <span lang="EN-GB">7. Data security</span>
                </b>
            </p>
            <p className="MsoNormal">
                <b>
                    <span lang="EN-GB">&nbsp;</span>
                </b>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">
                    We have put in place appropriate security measures to prevent your
                    personal data from being accidentally lost, used or accessed in an
                    unauthorised way, altered or disclosed. In addition, we limit access to
                    your personal data to those employees, agents, contractors and other
                    third parties who have a business need to know. They will only process
                    your personal data on our instructions and they are subject to a duty of
                    confidentiality.&nbsp;
                    <br />
                    <br />
                    We have put in place procedures to deal with any suspected personal data
                    breach and will notify you and any applicable regulator of a breach
                    where we are legally required to do so.&nbsp;
                    <br />
                    <br />
                    <br />
                </span>
            </p>
            <p className="MsoNormal">
                <b>
                    <span lang="EN-GB">8. Data retention</span>
                </b>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">&nbsp;</span>
            </p>
            <p className="MsoNormal">
                <b>
                    <span lang="EN-GB">How long will you use my personal data for?</span>
                </b>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">
                    We will only retain your personal data for as long as reasonably
                    necessary to fulfil the purposes we collected it for, including for the
                    purposes of satisfying any legal, regulatory, tax, accounting or
                    reporting requirements. We may retain your personal data for a longer
                    period in the event of a complaint or if we reasonably believe there is
                    a prospect of litigation in respect to our relationship with you.&nbsp;
                    <br />
                    <br />
                    To determine the appropriate retention period for personal data, we
                    consider the amount, nature and sensitivity of the personal data, the
                    potential risk of harm from unauthorised use or disclosure of your
                    personal data, the purposes for which we process your personal data and
                    whether we can achieve those purposes through other means, and the
                    applicable legal, regulatory, tax, accounting or other
                    requirements.&nbsp;
                    <br />
                    <br />
                    Details of retention periods for different aspects of your personal data
                    are available in our retention policy which you can request from us by
                    contacting us.&nbsp;
                    <br />
                    <br />
                    In some circumstances you can ask us to delete your data: see your legal
                    rights below for further information.&nbsp;
                    <br />
                    <br />
                    In some circumstances we will anonymise your personal data (so that it
                    can no longer be associated with you) for research or statistical
                    purposes, in which case we may use this information indefinitely without
                    further notice to you.&nbsp;
                    <br />
                    <br />
                    <br />
                </span>
            </p>
            <p className="MsoNormal">
                <b>
                    <span lang="EN-GB">9. Your legal rights</span>
                </b>
            </p>
            <p className="MsoNormal">
                <b>
                    <span lang="EN-GB">&nbsp;</span>
                </b>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">
                    Under certain circumstances, you have rights under data protection laws
                    in relation to your personal data. Please click on the links below to
                    find out more about these rights:&nbsp;
                    <br />
                    <br />
                    • Request access to your personal data.&nbsp;
                    <br />
                    <br />
                    • Request correction of your personal data.&nbsp;
                    <br />
                    <br />
                    • Request erasure of your personal data.&nbsp;
                    <br />
                    <br />
                    • Object to processing of your personal data.&nbsp;
                    <br />
                    <br />
                    • Request restriction of processing your personal data.&nbsp;
                    <br />
                    <br />
                    • Request transfer of your personal data.&nbsp;
                    <br />
                    <br />
                    • Right to withdraw consent.&nbsp;
                    <br />
                    <br />
                    If you wish to exercise any of the rights set out above, please contact
                    us.&nbsp;
                    <br />
                    <br />
                    <b>No fee usually required</b>
                </span>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">
                    You will not have to pay a fee to access your personal data (or to
                    exercise any of the other rights). However, we may charge a reasonable
                    fee if your request is clearly unfounded, repetitive or excessive.
                    Alternatively, we could refuse to comply with your request in these
                    circumstances.&nbsp;
                    <br />
                    <br />
                </span>
            </p>
            <p className="MsoNormal">
                <b>
                    <span lang="EN-GB">What we may need from you</span>
                </b>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">
                    We may need to request specific information from you to help us confirm
                    your identity and ensure your right to access your personal data (or to
                    exercise any of your other rights). This is a security measure to ensure
                    that personal data is not disclosed to any person who has no right to
                    receive it. We may also contact you to ask you for further information
                    in relation to your request to speed up our response.&nbsp;
                    <br />
                    <br />
                    <b>Time limit to respond</b>
                </span>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">
                    We try to respond to all legitimate requests within one month.
                    Occasionally it could take us longer than a month if your request is
                    particularly complex or you have made a number of requests. In this
                    case, we will notify you and keep you updated.&nbsp;
                    <br />
                    <br />
                    <br />
                </span>
            </p>
            <p className="MsoNormal">
                <b>
                    <span lang="EN-GB">
                        10. Glossary
                        <br />
                        <br />
                    </span>
                </b>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">LAWFUL BASIS</span>
            </p>
            <p className="MsoNormal">
                <b>
                    <span lang="EN-GB">Legitimate Interest</span>
                </b>
                <span lang="EN-GB">
                    &nbsp;means the interest of our business in conducting and managing our
                    business to enable us to give you the best service/product and the best
                    and most secure experience. We make sure we consider and balance any
                    potential impact on you (both positive and negative) and your rights
                    before we process your personal data for our legitimate interests. We do
                    not use your personal data for activities where our interests are
                    overridden by the impact on you (unless we have your consent or are
                    otherwise required or permitted to by law). You can obtain further
                    information about how we assess our legitimate interests against any
                    potential impact on you in respect of specific activities by contacting
                    us.&nbsp;
                    <br />
                    <br />
                    <b>Performance of Contract</b>&nbsp;means processing your data where it
                    is necessary for the performance of a contract to which you are a party
                    or to take steps at your request before entering into such a
                    contract.&nbsp;
                    <br />
                    <br />
                    <b>Comply with a legal obligation</b>&nbsp;means processing your
                    personal data where it is necessary for compliance with a legal
                    obligation that we are subject to.&nbsp;
                    <br />
                    <br />
                    <br />
                </span>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">THIRD PARTIES</span>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">External Third Parties</span>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">
                    • Dental practices in the United Kingdom acting as controllers, for the
                    purposes of dentists contacting you to discuss treatment options,
                    following your specific request for them to do so via our website.&nbsp;
                    <br />
                    <br />
                    • Service providers acting as processors such as Cloudways Limited in
                    Malta who provide website hosting, IT and system administration
                    services.&nbsp;
                    <br />
                    <br />
                    • Professional advisers acting as processors or joint controllers
                    including lawyers, bankers, auditors and insurers based in the United
                    Kingdom who provide consultancy, banking, legal, insurance and
                    accounting services.&nbsp;
                    <br />
                    <br />
                    • HM Revenue &amp; Customs, regulators and other authorities acting as
                    processors or joint controllers based in the United Kingdom who require
                    reporting of processing activities in certain circumstances.&nbsp;
                    <br />
                    <br />
                    <br />
                </span>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">YOUR LEGAL RIGHTS</span>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">
                    You have the right to:&nbsp;
                    <br />
                    <b>Request access</b>&nbsp;to your personal data (commonly known as a
                    "data subject access request"). This enables you to receive a copy of
                    the personal data we hold about you and to check that we are lawfully
                    processing it.&nbsp;
                    <br />
                    <br />
                    <b>Request correction</b>&nbsp;of the personal data that we hold about
                    you. This enables you to have any incomplete or inaccurate data we hold
                    about you corrected, though we may need to verify the accuracy of the
                    new data you provide to us.&nbsp;
                    <br />
                    <br />
                    <b>Request erasure</b>&nbsp;of your personal data. This enables you to
                    ask us to delete or remove personal data where there is no good reason
                    for us continuing to process it. You also have the right to ask us to
                    delete or remove your personal data where you have successfully
                    exercised your right to object to processing (see below), where we may
                    have processed your information unlawfully or where we are required to
                    erase your personal data to comply with local law. Note, however, that
                    we may not always be able to comply with your request of erasure for
                    specific legal reasons which will be notified to you, if applicable, at
                    the time of your request.&nbsp;
                    <br />
                    <br />
                    <b>Object to processing</b>&nbsp;of your personal data where we are
                    relying on a legitimate interest (or those of a third party) and there
                    is something about your particular situation which makes you want to
                    object to processing on this ground as you feel it impacts on your
                    fundamental rights and freedoms. You also have the right to object where
                    we are processing your personal data for direct marketing purposes. In
                    some cases, we may demonstrate that we have compelling legitimate
                    grounds to process your information which override your rights and
                    freedoms.&nbsp;
                    <br />
                    <br />
                    <b>Request restriction of processing</b>&nbsp;of your personal data.
                    This enables you to ask us to suspend the processing of your personal
                    data in the following scenarios:&nbsp;
                    <br />
                    <br />
                    • If you want us to establish the data's accuracy.&nbsp;
                    <br />
                    <br />
                    • Where our use of the data is unlawful but you do not want us to erase
                    it.&nbsp;
                    <br />
                    <br />
                    • Where you need us to hold the data even if we no longer require it as
                    you need it to establish, exercise or defend legal claims.&nbsp;
                    <br />
                    <br />
                    • You have objected to our use of your data but we need to verify
                    whether we have overriding legitimate grounds to use it.&nbsp;
                    <br />
                    <br />
                    <b>Request the transfer</b>&nbsp;of your personal data to you or to a
                    third party. We will provide to you, or a third party you have chosen,
                    your personal data in a structured, commonly used, machine-readable
                    format. Note that this right only applies to automated information which
                    you initially provided consent for us to use or where we used the
                    information to perform a contract with you.&nbsp;
                    <br />
                    <br />
                    <b>Withdraw consent at any time</b>&nbsp;where we are relying on consent
                    to process your personal data. However, this will not affect the
                    lawfulness of any processing carried out before you withdraw your
                    consent. If you withdraw your consent, we may not be able to provide
                    certain products or services to you. We will advise you if this is the
                    case at the time you withdraw your consent.
                </span>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">&nbsp;</span>
            </p>
            <p className="MsoNormal">
                <span lang="EN-GB">&nbsp;</span>
            </p>
        </div>

    );
};

export default SmileSection;
